import { getters } from "@/constants/state";

export default {
  [getters.SCENARIOS_OVERVIEW_GETTER]: (state) => state.scenarios,
  [getters.SCENARIOS_SCENARIO_GETTER]: (state) => state.scenario,
};
